import { showDialog } from 'dialogs';
import EditReportDefinition from '../EditReportDefinition';

/**
 * Open the report-definition edit modal via showDialog. `EditReportDefinition`
 * loads the record from the id and closes itself on save; `onSaved` runs on a
 * successful save so the caller can refresh.
 */
export const showEditReportDefinition = (id: number, onSaved: () => void): void => {
  showDialog((close) => <EditReportDefinition show onClose={close} selectedReportId={id} onSave={() => onSaved()} />);
};
